<script setup lang="ts">
interface Badge {
  icon?: string;
  label: string;
}
const props = defineProps<Badge>();
</script>
<template>
  <figure class="badge">
    <span>
      {{ label }}
    </span>
    <span v-if="icon" :class="`pi pi-${icon}`"></span>
  </figure>
</template>

<style scoped lang="postcss">
.badge {
  font-size: var(--font-size-8);
  background-color: oklch(var(--dark-grey-color) / 30%);
  border-radius: var(--border-radius-2);
  backdrop-filter: var(--blur-1);
  padding: 1px var(--grid-gap-1);
  width: fit-content;
  display: flex;
  color: oklch(1 0 0);
  align-items: center;
  justify-content: center;
  border: var(--border-1);

  .pi {
    font-size: var(--font-size-);
    margin-left: var(--grid-gap-1);
  }
}
</style>
